var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenAiGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,24.7c1.3-4,0.9-8.3-1.2-11.9c-3.2-5.5-9.5-8.4-15.8-7C35.1,2.7,31.1,0.9,27,0.9c-6.4,0-12,4.1-14,10.1 c-4.1,0.8-7.6,3.4-9.7,7c-3.2,5.5-2.5,12.4,1.8,17.2c-1.3,4-0.9,8.3,1.2,11.9c3.2,5.5,9.5,8.4,15.8,7c2.8,3.1,6.7,4.9,10.9,4.9 c6.4,0,12-4.1,14-10.1c4.1-0.8,7.6-3.4,9.7-7C59.9,36.4,59.2,29.4,54.9,24.7L54.9,24.7z M33,55.3c-2.5,0-5-0.9-7-2.5 c0.1,0,0.2-0.1,0.3-0.2L38,45.9c0.6-0.3,1-1,1-1.6V27.9l4.9,2.8c0.1,0,0.1,0.1,0.1,0.1v13.5C43.9,50.4,39.1,55.2,33,55.3L33,55.3z  M9.7,45.3c-1.3-2.2-1.7-4.8-1.3-7.3c0.1,0.1,0.2,0.1,0.3,0.2l11.6,6.7c0.6,0.3,1.3,0.3,1.9,0l14.1-8.2v5.6c0,0.1,0,0.1-0.1,0.2 l-11.7,6.8C19.3,52.2,12.7,50.5,9.7,45.3L9.7,45.3z M6.6,20c1.3-2.2,3.3-3.9,5.7-4.8c0,0.1,0,0.3,0,0.4V29c0,0.7,0.4,1.3,0.9,1.6 l14.1,8.2l-4.9,2.8c0,0-0.1,0-0.2,0l-11.7-6.8C5.4,31.9,3.6,25.2,6.6,20L6.6,20z M46.8,29.4l-14.1-8.2l4.9-2.8c0,0,0.1,0,0.2,0 l11.7,6.8c5.2,3,7,9.7,4,14.9c-1.3,2.2-3.3,3.9-5.7,4.8V31C47.7,30.3,47.4,29.7,46.8,29.4L46.8,29.4L46.8,29.4z M51.6,22 c-0.1-0.1-0.2-0.1-0.3-0.2l-11.6-6.7c-0.6-0.3-1.3-0.3-1.9,0l-14.1,8.2v-5.6c0-0.1,0-0.1,0.1-0.2l11.7-6.7c5.2-3,11.9-1.2,14.9,4 C51.6,17,52.1,19.5,51.6,22L51.6,22z M21.1,32.1l-4.9-2.8c-0.1,0-0.1-0.1-0.1-0.1V15.6c0-6,4.9-10.9,10.9-10.9c2.5,0,5,0.9,7,2.5 c-0.1,0-0.2,0.1-0.3,0.2L22,14.1c-0.6,0.3-1,1-1,1.6L21.1,32.1L21.1,32.1z M23.7,26.4l6.3-3.6l6.3,3.6v7.3L30,37.3l-6.3-3.6V26.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAiGreen);
export default __webpack_public_path__ + "static/media/OpenAI Green.c7e2ca28d75bee2d9474fca76a7aa9d9.svg";
export { ForwardRef as ReactComponent };